import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const Field = ({ labelWidth, control }: { labelWidth: string; control: string }) => (
  <div className="space-y-2">
    <Skeleton className={`h-4 ${labelWidth}`} />
    <Skeleton className={control} />
  </div>
)

const ProjectInfoSkeleton: React.FC = () => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <Field labelWidth="w-16" control="h-10 w-full" /> {/* Name */}
          <div className="space-y-1.5">
            <Field labelWidth="w-24" control="h-10 w-full" /> {/* Project code */}
            <Skeleton className="h-3 w-64" /> {/* Code hint */}
          </div>
          <Field labelWidth="w-24" control="h-[136px] w-full" /> {/* Description */}
          <Field labelWidth="w-28" control="h-10 w-full" /> {/* Tender language */}
        </div>

        <div className="space-y-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" /> {/* Choose address */}
            <div className="flex gap-2">
              <Skeleton className="h-10 flex-1" />
              <Skeleton className="h-10 w-10" />
            </div>
          </div>
          <Field labelWidth="w-14" control="h-10 w-full" /> {/* Street */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Field labelWidth="w-10" control="h-10 w-full" /> {/* City */}
            <Field labelWidth="w-10" control="h-10 w-full" /> {/* ZIP */}
            <Field labelWidth="w-16" control="h-10 w-full" /> {/* Country */}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field labelWidth="w-16" control="h-10 w-full" /> {/* Latitude */}
            <Field labelWidth="w-20" control="h-10 w-full" /> {/* Longitude */}
          </div>
        </div>
      </div>

      <Skeleton className="mt-6 h-10 w-36" /> {/* Submit button */}
    </div>
  )
}

export default ProjectInfoSkeleton
